import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { actionSheetController, IonCard, IonCardTitle, IonCardHeader,IonCardSubtitle, IonItem, IonLabel, IonList, IonNote, IonButton } from '@ionic/vue';
  import { useWorkplace } from '@/composables/workplace';
  import { computed, onMounted } from "vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BookingManager',
  setup(__props) {

  const { state, fetchBookedWorkplaces, fetchLatestBookedWorkplaces, cancelBooking } = useWorkplace();

  onMounted(async () => {
    await fetchBookedWorkplaces();
  })

  const bookings = computed(() => state.data?.elements);

  const handleCancelBooking = async (bookingId: string) => {
    const actionSheet = await actionSheetController.create({
      header: 'You are about to cancel your booking. Are you sure?',
      buttons: [
        {
          text: 'Cancel Booking',
          role: 'destructive',
          handler: async () => {
            await cancelBooking(bookingId);
            await fetchBookedWorkplaces();
            await fetchLatestBookedWorkplaces();
          }
        }, {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    await actionSheet.present();
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(IonCard), { color: "light" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonCardHeader), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCardSubtitle), null, {
              default: _withCtx(() => [
                _createTextVNode("Manage")
              ]),
              _: 1
            }),
            _createVNode(_unref(IonCardTitle), null, {
              default: _withCtx(() => [
                _createTextVNode("Bookings")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_unref(bookings) && _unref(bookings).length > 0)
          ? (_openBlock(), _createBlock(_unref(IonList), { key: 0 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bookings), (booking) => {
                  return (_openBlock(), _createBlock(_unref(IonItem), {
                    color: "transparent",
                    lines: "none",
                    key: booking.id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createElementVNode("small", _hoisted_1, _toDisplayString(new Date(booking.bookingDate.split('T')[0]).toLocaleDateString('de-de', { weekday: 'short', month: 'long', day: 'numeric' })), 1),
                          _hoisted_2,
                          _createElementVNode("strong", null, _toDisplayString(booking.workplace.name), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_unref(IonNote), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonButton), {
                            onClick: _withModifiers(($event: any) => (handleCancelBooking(booking.id)), ["prevent"]),
                            color: "danger"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Cancel")
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})